export function ImageOverlay(style) {
  return {
    setImageUrl(url) {
      this.bounds = this.getMap().getBounds();
      this.image.src = url;
      this.draw();
    },

    setStyle(styles = {}) {
      const { visible, fillOpacity, zIndex } = styles;

      if (zIndex !== undefined && this.image) {
        this.container.style.zIndex = zIndex;
      }

      if (visible !== undefined && this.image) {
        this.image.style.visibility = visible ? 'visible' : 'hidden';
      }

      if (fillOpacity !== undefined && this.image) {
        this.image.style.opacity = fillOpacity;
      }
    },

    onAdd() {
      this.image = document.createElement('img');
      this.image.style.width = '100%';
      this.image.style.height = '100%';
      this.image.style.position = 'absolute';

      this.container = document.createElement('div');
      this.container.style.borderStyle = 'none';
      this.container.style.borderWidth = '0px';
      this.container.style.position = 'absolute';
      this.container.style.zIndex = style.zIndex;
      this.container.appendChild(this.image);

      this.getPanes().overlayLayer.appendChild(this.container);
    },

    draw() {
      if (this.bounds) {
        const projection = this.getProjection();
        const sw = projection.fromLatLngToDivPixel(this.bounds.getSouthWest());
        const ne = projection.fromLatLngToDivPixel(this.bounds.getNorthEast());

        this.container.style.left = `${sw.x}px`;
        this.container.style.top = `${ne.y}px`;
        this.container.style.width = `${ne.x - sw.x}px`;
        this.container.style.height = `${sw.y - ne.y}px`;
      }
    },
  };
}
